import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AnimeGrid from './components/AnimeGrid';
import DetailModal from './components/DetailModal';
import FightAnimation from './components/FightLoader';
import './App.css';
import Footer from './components/Footer';

const API_KEY = 'c06775d7';
const API_BASE = 'https://www.omdbapi.com/';

const TOP_ANIME_IDS = [
  { id: 'tt0988824' }, // Fullmetal Alchemist: Brotherhood
  { id: 'tt2560140' }, // Attack on Titan
  { id: 'tt0245429' }, // Spirited Away
  { id: 'tt0434409' }, // Steins;Gate
  { id: 'tt0409591' }, // Naruto
  { id: 'tt9335498' }, // Demon Slayer
];

function App() {
  const [query, setQuery] = useState('');
  const [minYear, setMinYear] = useState(1990);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedAnime, setSelectedAnime] = useState(null);
  const [activeTab, setActiveTab] = useState('search');
  const [topAnime, setTopAnime] = useState([]);
  const [topLoaded, setTopLoaded] = useState(false);
  const [topLoading, setTopLoading] = useState(false);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setError('');
    setResults([]);
    try {
      const searchRes = await fetch(
        `${API_BASE}?s=${encodeURIComponent(query)}&type=series&apikey=${API_KEY}`
      );
      const searchData = await searchRes.json();
      if (searchData.Response === 'False' || !searchData.Search) {
        setError('No results found. Try a different title.');
        setLoading(false);
        return;
      }
      const filtered = searchData.Search
        .filter(item => parseInt(item.Year) >= minYear)
        .slice(0, 6);
      if (!filtered.length) {
        setError('No results match your year filter.');
        setLoading(false);
        return;
      }
      const details = await Promise.all(
        filtered.map(item =>
          fetch(`${API_BASE}?i=${item.imdbID}&apikey=${API_KEY}`).then(r => r.json())
        )
      );
      setResults(details);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    if (tab === 'top' && !topLoaded) {
      setTopLoading(true);
      try {
        const data = await Promise.all(
          TOP_ANIME_IDS.map(a =>
            fetch(`${API_BASE}?i=${a.id}&apikey=${API_KEY}`).then(r => r.json())
          )
        );
        setTopAnime(data);
        setTopLoaded(true);
      } catch (err) {
        console.error('Failed to load top anime');
      } finally {
        setTopLoading(false);
      }
    }
  };

  return (
    <div className="app">
      <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
      {activeTab === 'search' && (
        <>
          <Hero
            query={query}
            setQuery={setQuery}
            minYear={minYear}
            setMinYear={setMinYear}
            onSearch={handleSearch}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
          />
          <main className="main-content">
            {loading && <p className="status-msg">Searching...</p>}
            {!loading && error && <p className="status-msg">{error}</p>}
            {!loading && !error && results.length === 0 && (
              <p className="status-msg">Search for any anime title above to get started.</p>
            )}
            {!loading && results.length > 0 && (
              <AnimeGrid items={results} onSelect={setSelectedAnime} />
            )}
          </main>
        </>
      )}
      {activeTab === 'top' && (
        <main className="main-content top-section">
          <div className="section-header">
            <h2>Top Rated Anime</h2>
            <p>The most acclaimed series, pulled live from OMDB.</p>
          </div>
          {topLoading && <p className="status-msg">Loading...</p>}
          {!topLoading && <AnimeGrid items={topAnime} onSelect={setSelectedAnime} />}
        </main>
      )}
      {selectedAnime && (
        <DetailModal
          imdbID={selectedAnime}
          apiKey={API_KEY}
          apiBase={API_BASE}
          onClose={() => setSelectedAnime(null)}
        />
      )}
      <Footer />
    </div>
  );
}

export default App;